export default __webpack_public_path__ + "static/media/arrowLeftGray.a5819105.svg";